import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

/* eslint-disable no-dupe-keys */
const resources = {
  en: {
    translation: {
      "Exchange Skills": "Exchange Skills.",
      "Grow Together": "Grow Together.",
      "Hero Description": "A peer-to-peer ecosystem where you teach what you know and learn what you don't. Connect with mentors globally, earn credits, and level up your skills!",
      "Explore Skills": "Explore Skills",
      "Join the Community": "Join the Community",
      "Barter Skills": "Barter Skills",
      "Barter Desc": "Teach coding, learn guitar. Exchange what you know for what you need.",
      "Live Video": "Live Video Sessions",
      "Video Desc": "Real-time video calls with screen sharing and in-app chat.",
      "Earn Grow": "Earn & Grow",
      "Earn Desc": "Earn credits, badges, and climb the leaderboard as you help others.",
      "Search": "Search...",
      "Explore": "Explore",
      "Dashboard": "Dashboard",
      "Sessions": "Sessions",
      "Chat": "Chat",
      "Rankings": "Rankings",
      "Community": "Community",
      "Sign In": "Sign In",
      "Get Started": "Get Started",
      "Profile": "Profile",
      "Logout": "Logout",
      "Welcome back": "Welcome back, {{name}} 👋",
      "Portfolio desc": "Here's what's happening with your skill portfolio",
      "View Profile": "View Profile",
      "Credits Available": "Credits Available",
      "Skills Teaching": "Skills Teaching",
      "Pending Sessions": "Pending Sessions",
      "Completed": "Completed",
      "Personal Analytics": "Personal Analytics",
      "Sessions (Last 6 Months)": "Sessions (Last 6 Months)",
      "Skill Demand (Requests Received)": "Skill Demand (Requests Received)",
      "Your Skills Portfolio": "Your Skills Portfolio",
      "Add a new skill": "Add a new skill",
      "Category": "Category",
      "Skill": "Skill",
      "I want to TEACH": "I want to TEACH",
      "I want to LEARN": "I want to LEARN",
      "Add": "Add",
      "Skills You Teach": "Skills You Teach",
      "Skills You Want to Learn": "Skills You Want to Learn",
      "Recent Sessions": "Recent Sessions",
      "View All": "View All →",
      "Recommended Mentors": "Recommended Mentors",
      "Explore More": "Explore More →",
      "Book Session": "Book Session",
      "Find Mentors": "Find Mentors",
      "Messages": "Messages",
      "Explore Mentors": "Explore Mentors",
      "Discover skilled people": "Discover skilled people ready to share their knowledge",
      "Search Skills": "Search Skills",
      "Search Placeholder": "e.g. React, Guitar, Photography...",
      "All Categories": "All Categories",
      "Specific Skill": "Specific Skill",
      "All Skills in Category": "All Skills in Category",
      "Select category first": "Select category first or type above",
      "Min Rating": "Min Rating",
      "Any": "Any",
      "Sort By": "Sort By",
      "Newest": "Newest",
      "Highest Rated": "Highest Rated",
      "Most Reviewed": "Most Reviewed",
      "Most Experienced": "Most Experienced",
      "Search": "Search",
      "Clear Filters": "Clear Filters",
      "No mentors found": "No mentors found",
      "Try adjusting filters": "Try adjusting your search filters",
      "Message": "Message",
      "Your Sessions": "Your Sessions",
      "Manage your learning": "Manage your learning and mentoring schedule",
      "upcoming": "upcoming",
      "pending": "pending",
      "past": "past",
      "completed": "completed",
      "uncompleted": "uncompleted",
      "No session history found.": "No session history found.",
      "You don't have any sessions scheduled yet.": "You don't have any sessions scheduled yet.",
      "No upcoming sessions": "No upcoming sessions",
      "No pending sessions": "No pending sessions",
      "No past sessions": "No past sessions",
      "No completed sessions": "No completed sessions",
      "No uncompleted sessions": "No uncompleted sessions",
      "You have no pending session requests.": "You have no pending session requests.",
      "You haven't completed any sessions yet.": "You haven't completed any sessions yet.",
      "You don't have any uncompleted sessions.": "You don't have any uncompleted sessions.",
      "Find a Mentor": "Find a Mentor",
      "Mentoring": "Mentoring",
      "Learning": "Learning",
      "Date": "Date",
      "Time": "Time",
      "Session Goals": "Session Goals",
      "Accept": "Accept",
      "Decline": "Decline",
      "Join Room": "Join Room",
      "Send Message": "Send Message",
      "Shared Notes & Resources": "Shared Notes & Resources",
      "Type your notes": "Type your notes or paste resource links...",
      "Cancel": "Cancel",
      "Save Note": "Save Note",
      "+ Add Session Note": "+ Add Session Note",
      "reviews": "reviews",
      "No bio yet": "No bio yet.",
      "Credits": "Credits",
      "Sessions Taught": "Sessions Taught",
      "Sessions Learned": "Sessions Learned",
      "Day Streak": "Day Streak",
      "Profile Completeness": "Profile Completeness",
      "Hover for tips": "(Hover for tips)",
      "To reach 100%": "To reach 100%:",
      "Add your name": "Add your name",
      "Add a short bio": "Add a short bio",
      "Add your location": "Add your location",
      "Upload an avatar": "Upload an avatar",
      "Add skills you can teach": "Add skills you can teach",
      "Add skills you want to learn": "Add skills you want to learn",
      "Edit Profile": "Edit Profile",
      "Name": "Name",
      "Location": "Location",
      "Bio": "Bio",
      "GitHub URL": "GitHub URL",
      "LinkedIn URL": "LinkedIn URL",
      "Save Changes": "Save Changes",
      "Skills": "Skills",
      "Teaching": "Teaching",
      "No teaching skills": "No teaching skills added yet",
      "No learning skills": "No learning skills added yet",
      "Badges & Achievements": "Badges & Achievements",
      "No badges earned": "No badges earned yet. Complete sessions to earn badges!",
      "Reviews": "Reviews",
      "No reviews yet": "No reviews yet",
      "Danger Zone": "Danger Zone",
      "Danger Text": "Once you delete your account, there is no going back. All your sessions, skills, reviews, and messages will be permanently deleted.",
      "Delete Account": "Delete Account",

      "No conversations yet": "No conversations yet. Message someone from Explore!",
      "Unknown": "Unknown",
      "No messages yet": "No messages yet",
      "is typing...": "is typing...",
      "Type a message...": "Type a message...",
      "Select a conversation": "Select a conversation",
      "Choose a conversation": "Choose a conversation from the sidebar to start chatting",

      "Leaderboard": "Leaderboard",
      "Our top learners": "Our top learners in the community",
      "Our top mentors": "Our top mentors in the community",
      "Top Mentors": "Top Mentors",
      "Top Learners": "Top Learners",
      "All": "All",
      "No leaders yet": "No leaders yet",
      "Complete sessions to appear": "Complete sessions and earn reviews to appear here!",
      "learned": "learned",

      "Community Spaces": "Community Spaces",
      "Join skill-specific communities": "Join skill-specific communities and connect with others",
      "+ Create Community": "+ Create Community",
      "No communities yet": "No communities yet",
      "Be the first to create": "Be the first to create a community!",
      "members": "members",
      "Joined": "Joined",
      "Join": "Join",
      "Icon": "Icon",
      "e.g. React Developers": "e.g. React Developers",
      "Category": "Category",
      "e.g. Programming": "e.g. Programming",
      "Description": "Description",
      "What is this community about?": "What is this community about?",
      "Create": "Create",
      "Back to Communities": "← Back to Communities",
      "Leave": "Leave",
      "Join Community": "Join Community",
      "posts": "posts",
      "Share something": "Share something with the community...",
      "Post": "Post",
      "No posts yet": "No posts yet. Be the first to share!",
      "Edit": "Edit",
      "Delete": "Delete",
      "Save": "Save",
      "Write a reply...": "Write a reply...",
      "Reply": "Reply",

      "Welcome Back": "Welcome Back",
      "Please enter details": "Please enter your details to sign in",
      "Email Address": "Email Address",
      "Password": "Password",
      "Sign In": "Sign In",
      "Don't have an account?": "Don't have an account?",
      "Sign up here": "Sign up here",

      "Create an Account": "Create an Account",
      "Join the community today": "Join the community today",
      "Full Name": "Full Name",
      "Create Account": "Create Account",
      "Already have an account?": "Already have an account?",
      "Sign in here": "Sign in here",

      "Video Session": "Video Session",
      "End Session": "End Session",
      "Share Screen": "Share Screen",
      "Stop Screen": "Stop Screen",
      "Waiting for other": "Waiting for other participant to join...",
      "Weekly Challenges": "Weekly Challenges",
      "Claim Reward": "Claim Reward",
      "Claimed": "Claimed",
      "The Skill Sharer": "The Skill Sharer",
      "Complete 1 session as a Mentor this week": "Complete 1 session as a Mentor this week",
      "The Avid Learner": "The Avid Learner",
      "Complete 1 session as a Learner this week": "Complete 1 session as a Learner this week",
      "Community Voice": "Community Voice",
      "Write 1 post in any community this week": "Write 1 post in any community this week"
    }
  },
  hi: {
    translation: {
      "Exchange Skills": "कौशल का आदान-प्रदान करें।",
      "Grow Together": "एक साथ बढ़ें।",
      "Hero Description": "एक पीयर-टू-पीयर इकोसिस्टम जहां आप वह सिखाते हैं जो आप जानते हैं और वह सीखते हैं जो आप नहीं जानते। विश्व स्तर पर मेंटर्स से जुड़ें, क्रेडिट कमाएं, और अपने कौशल को बेहतर बनाएं!",
      "Explore Skills": "कौशल खोजें",
      "Join the Community": "समुदाय में शामिल हों",
      "Barter Skills": "वस्तु विनिमय कौशल",
      "Barter Desc": "कोडिंग सिखाएं, गिटार सीखें। जो आप जानते हैं उसे उसके बदले में बदलें जिसकी आपको आवश्यकता है।",
      "Live Video": "लाइव वीडियो सत्र",
      "Video Desc": "स्क्रीन शेयरिंग और इन-ऐप चैट के साथ रीयल-टाइम वीडियो कॉल।",
      "Earn Grow": "कमाएं और बढ़ें",
      "Earn Desc": "क्रेडिट, बैज अर्जित करें और दूसरों की मदद करते हुए लीडरबोर्ड पर चढ़ें।",
      "Search": "खोजें...",
      "Explore": "खोजें",
      "Dashboard": "डैशबोर्ड",
      "Sessions": "सत्र",
      "Chat": "चैट",
      "Rankings": "रैंकिंग",
      "Community": "समुदाय",
      "Sign In": "साइन इन",
      "Get Started": "शुरू करें",
      "Profile": "प्रोफ़ाइल",
      "Logout": "लॉग आउट",
      "Welcome back": "वापसी पर स्वागत है, {{name}} 👋",
      "Portfolio desc": "यहां आपके कौशल पोर्टफोलियो के साथ क्या हो रहा है",
      "View Profile": "प्रोफ़ाइल देखें",
      "Credits Available": "उपलब्ध क्रेडिट",
      "Skills Teaching": "कौशल शिक्षण",
      "Pending Sessions": "लंबित सत्र",
      "Completed": "पूरा हुआ",
      "Personal Analytics": "व्यक्तिगत विश्लेषण",
      "Sessions (Last 6 Months)": "सत्र (पिछले 6 महीने)",
      "Skill Demand (Requests Received)": "कौशल मांग (प्राप्त अनुरोध)",
      "Your Skills Portfolio": "आपका कौशल पोर्टफोलियो",
      "Add a new skill": "नया कौशल जोड़ें",
      "Category": "श्रेणी",
      "Skill": "कौशल",
      "I want to TEACH": "मैं पढ़ाना चाहता हूँ",
      "I want to LEARN": "मैं सीखना चाहता हूँ",
      "Add": "जोड़ें",
      "Skills You Teach": "कौशल जो आप सिखाते हैं",
      "Skills You Want to Learn": "कौशल जो आप सीखना चाहते हैं",
      "Recent Sessions": "हाल के सत्र",
      "View All": "सभी देखें →",
      "Recommended Mentors": "अनुशंसित मेंटर्स",
      "Explore More": "और खोजें →",
      "Book Session": "सत्र बुक करें",
      "Find Mentors": "मेंटर्स खोजें",
      "Messages": "संदेश",
      "Explore Mentors": "मेंटर्स खोजें",
      "Discover skilled people": "अपना ज्ञान साझा करने के लिए तैयार कुशल लोगों की खोज करें",
      "Search Skills": "कौशल खोजें",
      "Search Placeholder": "जैसे रिएक्ट, गिटार, फोटोग्राफी...",
      "All Categories": "सभी श्रेणियां",
      "Specific Skill": "विशिष्ट कौशल",
      "All Skills in Category": "श्रेणी में सभी कौशल",
      "Select category first": "पहले श्रेणी चुनें या ऊपर टाइप करें",
      "Min Rating": "न्यूनतम रेटिंग",
      "Any": "कोई भी",
      "Sort By": "क्रमबद्ध करें",
      "Newest": "सबसे नया",
      "Highest Rated": "उच्चतम रेटेड",
      "Most Reviewed": "सबसे अधिक समीक्षित",
      "Most Experienced": "सबसे अनुभवी",
      "Search": "खोजें",
      "Clear Filters": "फ़िल्टर साफ़ करें",
      "No mentors found": "कोई मेंटर नहीं मिला",
      "Try adjusting filters": "अपने खोज फ़िल्टर समायोजित करने का प्रयास करें",
      "Message": "संदेश",
      "Your Sessions": "आपके सत्र",
      "Manage your learning": "अपनी सीखने और मेंटरिंग अनुसूची प्रबंधित करें",
      "upcoming": "आगामी",
      "pending": "लंबित",
      "past": "अतीत",
      "completed": "पूर्ण",
      "uncompleted": "अपूर्ण",
      "No session history found.": "कोई सत्र इतिहास नहीं मिला।",
      "You don't have any sessions scheduled yet.": "आपने अभी तक कोई सत्र निर्धारित नहीं किया है।",
      "No upcoming sessions": "कोई आगामी सत्र नहीं",
      "No pending sessions": "कोई लंबित सत्र नहीं",
      "No past sessions": "कोई अतीत सत्र नहीं",
      "No completed sessions": "कोई पूर्ण सत्र नहीं",
      "No uncompleted sessions": "कोई अपूर्ण सत्र नहीं",
      "You have no pending session requests.": "आपके पास कोई लंबित सत्र अनुरोध नहीं है।",
      "You haven't completed any sessions yet.": "आपने अभी तक कोई सत्र पूरा नहीं किया है।",
      "You don't have any uncompleted sessions.": "आपके पास कोई अपूर्ण सत्र नहीं है।",
      "Find a Mentor": "एक मेंटर खोजें",
      "Mentoring": "मेंटरिंग",
      "Learning": "सीखना",
      "Date": "दिनांक",
      "Time": "समय",
      "Session Goals": "सत्र लक्ष्य",
      "Accept": "स्वीकार करें",
      "Decline": "अस्वीकार करें",
      "Join Room": "कमरे में शामिल हों",
      "Send Message": "संदेश भेजें",
      "Shared Notes & Resources": "साझा नोट्स और संसाधन",
      "Type your notes": "अपने नोट्स टाइप करें या संसाधन लिंक पेस्ट करें...",
      "Cancel": "रद्द करें",
      "Save Note": "नोट सहेजें",
      "+ Add Session Note": "+ सत्र नोट जोड़ें",
      "reviews": "समीक्षाएं",
      "No bio yet": "अभी तक कोई बायो नहीं।",
      "Credits": "क्रेडिट",
      "Sessions Taught": "सिखाए गए सत्र",
      "Sessions Learned": "सीखे गए सत्र",
      "Day Streak": "दिन की स्ट्रीक",
      "Profile Completeness": "प्रोफ़ाइल पूर्णता",
      "Hover for tips": "(सुझावों के लिए होवर करें)",
      "To reach 100%": "100% तक पहुंचने के लिए:",
      "Add your name": "अपना नाम जोड़ें",
      "Add a short bio": "एक छोटा बायो जोड़ें",
      "Add your location": "अपना स्थान जोड़ें",
      "Upload an avatar": "एक अवतार अपलोड करें",
      "Add skills you can teach": "कौशल जोड़ें जो आप सिखा सकते हैं",
      "Add skills you want to learn": "कौशल जोड़ें जो आप सीखना चाहते हैं",
      "Edit Profile": "प्रोफ़ाइल संपादित करें",
      "Name": "नाम",
      "Location": "स्थान",
      "Bio": "बायो",
      "GitHub URL": "गिटहब यूआरएल",
      "LinkedIn URL": "लिंक्डइन यूआरएल",
      "Save Changes": "परिवर्तन सहेजें",
      "Skills": "कौशल",
      "Teaching": "शिक्षण",
      "No teaching skills": "अभी तक कोई शिक्षण कौशल नहीं जोड़ा गया",
      "No learning skills": "अभी तक कोई सीखने का कौशल नहीं जोड़ा गया",
      "Badges & Achievements": "बैज और उपलब्धियां",
      "No badges earned": "अभी तक कोई बैज नहीं मिला। बैज अर्जित करने के लिए सत्र पूरे करें!",
      "Reviews": "समीक्षाएं",
      "No reviews yet": "अभी तक कोई समीक्षा नहीं",
      "Danger Zone": "खतरे का क्षेत्र",
      "Danger Text": "एक बार जब आप अपना खाता हटा देते हैं, तो वापस जाने का कोई रास्ता नहीं है। आपके सभी सत्र, कौशल, समीक्षाएं और संदेश स्थायी रूप से हटा दिए जाएंगे।",
      "Delete Account": "खाता हटाएं",

      "No conversations yet": "अभी तक कोई बातचीत नहीं। एक्सप्लोर से किसी को संदेश भेजें!",
      "Unknown": "अज्ञात",
      "No messages yet": "अभी तक कोई संदेश नहीं",
      "is typing...": "टाइप कर रहा है...",
      "Type a message...": "एक संदेश टाइप करें...",
      "Select a conversation": "एक बातचीत चुनें",
      "Choose a conversation": "चैटिंग शुरू करने के लिए साइडबार से एक बातचीत चुनें",

      "Leaderboard": "लीडरबोर्ड",
      "Our top learners": "समुदाय में हमारे शीर्ष शिक्षार्थी",
      "Our top mentors": "समुदाय में हमारे शीर्ष मेंटर्स",
      "Top Mentors": "शीर्ष मेंटर्स",
      "Top Learners": "शीर्ष शिक्षार्थी",
      "All": "सभी",
      "No leaders yet": "अभी तक कोई नेता नहीं",
      "Complete sessions to appear": "सत्र पूरा करें और यहां दिखाई देने के लिए समीक्षाएं अर्जित करें!",
      "learned": "सीखा",

      "Community Spaces": "सामुदायिक स्थान",
      "Join skill-specific communities": "कौशल-विशिष्ट समुदायों में शामिल हों और दूसरों के साथ जुड़ें",
      "+ Create Community": "+ समुदाय बनाएं",
      "No communities yet": "अभी तक कोई समुदाय नहीं",
      "Be the first to create": "समुदाय बनाने वाले पहले व्यक्ति बनें!",
      "members": "सदस्य",
      "Joined": "शामिल हुए",
      "Join": "शामिल हों",
      "Icon": "आइकन",
      "e.g. React Developers": "जैसे रिएक्ट डेवलपर्स",
      "Category": "श्रेणी",
      "e.g. Programming": "जैसे प्रोग्रामिंग",
      "Description": "विवरण",
      "What is this community about?": "यह समुदाय किस बारे में है?",
      "Create": "बनाएं",
      "Back to Communities": "← समुदायों पर वापस जाएं",
      "Leave": "छोड़ें",
      "Join Community": "समुदाय में शामिल हों",
      "posts": "पोस्ट",
      "Share something": "समुदाय के साथ कुछ साझा करें...",
      "Post": "पोस्ट",
      "No posts yet": "अभी तक कोई पोस्ट नहीं। साझा करने वाले पहले व्यक्ति बनें!",
      "Edit": "संपादित करें",
      "Delete": "हटाएं",
      "Save": "सहेजें",
      "Write a reply...": "एक उत्तर लिखें...",
      "Reply": "उत्तर",

      "Welcome Back": "वापसी पर स्वागत है",
      "Please enter details": "साइन इन करने के लिए कृपया अपना विवरण दर्ज करें",
      "Email Address": "ईमेल पता",
      "Password": "पासवर्ड",
      "Sign In": "साइन इन करें",
      "Don't have an account?": "क्या आपके पास खाता नहीं है?",
      "Sign up here": "यहां साइन अप करें",

      "Create an Account": "खाता बनाएं",
      "Join the community today": "आज ही समुदाय में शामिल हों",
      "Full Name": "पूरा नाम",
      "Create Account": "खाता बनाएं",
      "Already have an account?": "क्या आपके पास पहले से खाता है?",
      "Sign in here": "यहां साइन इन करें",

      "Video Session": "वीडियो सत्र",
      "End Session": "सत्र समाप्त करें",
      "Share Screen": "स्क्रीन साझा करें",
      "Stop Screen": "स्क्रीन रोकें",
      "Waiting for other": "अन्य प्रतिभागी के शामिल होने की प्रतीक्षा कर रहा है...",
      "Weekly Challenges": "साप्ताहिक चुनौतियाँ",
      "Claim Reward": "पुरस्कार का दावा करें",
      "Claimed": "दावा किया गया",
      "The Skill Sharer": "कौशल साझा करने वाला",
      "Complete 1 session as a Mentor this week": "इस सप्ताह मेंटर के रूप में 1 सत्र पूरा करें",
      "The Avid Learner": "उत्सुक शिक्षार्थी",
      "Complete 1 session as a Learner this week": "इस सप्ताह शिक्षार्थी के रूप में 1 सत्र पूरा करें",
      "Community Voice": "सामुदायिक आवाज",
      "Write 1 post in any community this week": "इस सप्ताह किसी भी समुदाय में 1 पोस्ट लिखें"
    }
  },
  es: {
    translation: {
      "Exchange Skills": "Intercambiar Habilidades.",
      "Grow Together": "Crecer Juntos.",
      "Hero Description": "Un ecosistema de igual a igual donde enseñas lo que sabes y aprendes lo que no. ¡Conéctate con mentores globalmente, gana créditos y mejora tus habilidades!",
      "Explore Skills": "Explorar Habilidades",
      "Join the Community": "Únete a la Comunidad",
      "Barter Skills": "Habilidades de Trueque",
      "Barter Desc": "Enseña programación, aprende guitarra. Intercambia lo que sabes por lo que necesitas.",
      "Live Video": "Sesiones de Video en Vivo",
      "Video Desc": "Videollamadas en tiempo real con uso compartido de pantalla y chat en la aplicación.",
      "Earn Grow": "Gana y Crece",
      "Earn Desc": "Gana créditos, insignias y sube en la clasificación mientras ayudas a otros.",
      "Search": "Buscar...",
      "Explore": "Explorar",
      "Dashboard": "Panel",
      "Sessions": "Sesiones",
      "Chat": "Chat",
      "Rankings": "Clasificaciones",
      "Community": "Comunidad",
      "Sign In": "Iniciar Sesión",
      "Get Started": "Empezar",
      "Profile": "Perfil",
      "Logout": "Cerrar sesión",
      "Welcome back": "Bienvenido de nuevo, {{name}} 👋",
      "Portfolio desc": "Esto es lo que sucede con tu cartera de habilidades",
      "View Profile": "Ver Perfil",
      "Credits Available": "Créditos Disponibles",
      "Skills Teaching": "Enseñando Habilidades",
      "Pending Sessions": "Sesiones Pendientes",
      "Completed": "Completado",
      "Personal Analytics": "Análisis Personal",
      "Sessions (Last 6 Months)": "Sesiones (Últimos 6 meses)",
      "Skill Demand (Requests Received)": "Demanda de Habilidades (Solicitudes Recibidas)",
      "Your Skills Portfolio": "Tu Cartera de Habilidades",
      "Add a new skill": "Añadir una nueva habilidad",
      "Category": "Categoría",
      "Skill": "Habilidad",
      "I want to TEACH": "Quiero ENSEÑAR",
      "I want to LEARN": "Quiero APRENDER",
      "Add": "Añadir",
      "Skills You Teach": "Habilidades que enseñas",
      "Skills You Want to Learn": "Habilidades que quieres aprender",
      "Recent Sessions": "Sesiones Recientes",
      "View All": "Ver Todo →",
      "Recommended Mentors": "Mentores Recomendados",
      "Explore More": "Explorar Más →",
      "Book Session": "Reservar Sesión",
      "Find Mentors": "Encontrar Mentores",
      "Messages": "Mensajes",
      "Explore Mentors": "Explorar Mentores",
      "Discover skilled people": "Descubre personas capacitadas listas para compartir sus conocimientos",
      "Search Skills": "Buscar Habilidades",
      "Search Placeholder": "ej. React, Guitarra, Fotografía...",
      "All Categories": "Todas las Categorías",
      "Specific Skill": "Habilidad Específica",
      "All Skills in Category": "Todas las Habilidades en la Categoría",
      "Select category first": "Selecciona la categoría primero o escribe arriba",
      "Min Rating": "Calificación Mínima",
      "Any": "Cualquiera",
      "Sort By": "Ordenar Por",
      "Newest": "Más Recientes",
      "Highest Rated": "Mejor Calificados",
      "Most Reviewed": "Más Revisados",
      "Most Experienced": "Más Experimentados",
      "Search": "Buscar",
      "Clear Filters": "Borrar Filtros",
      "No mentors found": "No se encontraron mentores",
      "Try adjusting filters": "Intenta ajustar tus filtros de búsqueda",
      "Message": "Mensaje",
      "Your Sessions": "Tus Sesiones",
      "Manage your learning": "Administra tu horario de aprendizaje y mentoría",
      "upcoming": "próximo",
      "pending": "pendiente",
      "past": "pasado",
      "completed": "completado",
      "uncompleted": "no completado",
      "No session history found.": "No se encontró historial de sesiones.",
      "You don't have any sessions scheduled yet.": "Aún no tienes sesiones programadas.",
      "No upcoming sessions": "No hay sesiones próximas",
      "No pending sessions": "No hay sesiones pendientes",
      "No past sessions": "No hay sesiones pasadas",
      "No completed sessions": "No hay sesiones completadas",
      "No uncompleted sessions": "No hay sesiones incompletas",
      "You have no pending session requests.": "No tienes solicitudes de sesión pendientes.",
      "You haven't completed any sessions yet.": "Aún no has completado ninguna sesión.",
      "You don't have any uncompleted sessions.": "No tienes sesiones incompletas.",
      "Find a Mentor": "Encuentra un Mentor",
      "Mentoring": "Mentoría",
      "Learning": "Aprendizaje",
      "Date": "Fecha",
      "Time": "Hora",
      "Session Goals": "Objetivos de la Sesión",
      "Accept": "Aceptar",
      "Decline": "Rechazar",
      "Join Room": "Entrar a la Sala",
      "Send Message": "Enviar Mensaje",
      "Shared Notes & Resources": "Notas y Recursos Compartidos",
      "Type your notes": "Escribe tus notas o pega enlaces a recursos...",
      "Cancel": "Cancelar",
      "Save Note": "Guardar Nota",
      "+ Add Session Note": "+ Añadir Nota de Sesión",
      "reviews": "reseñas",
      "No bio yet": "Aún no hay biografía.",
      "Credits": "Créditos",
      "Sessions Taught": "Sesiones Impartidas",
      "Sessions Learned": "Sesiones Aprendidas",
      "Day Streak": "Racha de días",
      "Profile Completeness": "Perfil Completado",
      "Hover for tips": "(Pasa el ratón para ver consejos)",
      "To reach 100%": "Para llegar al 100%:",
      "Add your name": "Añade tu nombre",
      "Add a short bio": "Añade una breve biografía",
      "Add your location": "Añade tu ubicación",
      "Upload an avatar": "Sube un avatar",
      "Add skills you can teach": "Añade habilidades que puedes enseñar",
      "Add skills you want to learn": "Añade habilidades que quieres aprender",
      "Edit Profile": "Editar Perfil",
      "Name": "Nombre",
      "Location": "Ubicación",
      "Bio": "Biografía",
      "GitHub URL": "URL de GitHub",
      "LinkedIn URL": "URL de LinkedIn",
      "Save Changes": "Guardar Cambios",
      "Skills": "Habilidades",
      "Teaching": "Enseñando",
      "No teaching skills": "No se han añadido habilidades de enseñanza",
      "No learning skills": "No se han añadido habilidades de aprendizaje",
      "Badges & Achievements": "Insignias y Logros",
      "No badges earned": "Aún no has ganado insignias. ¡Completa sesiones para ganarlas!",
      "Reviews": "Reseñas",
      "No reviews yet": "Aún no hay reseñas",
      "Danger Zone": "Zona de Peligro",
      "Danger Text": "Una vez que elimines tu cuenta, no hay vuelta atrás. Todas tus sesiones, habilidades, reseñas y mensajes se eliminarán permanentemente.",
      "Delete Account": "Eliminar Cuenta",

      "No conversations yet": "Aún no hay conversaciones. ¡Envía un mensaje a alguien desde Explorar!",
      "Unknown": "Desconocido",
      "No messages yet": "Aún no hay mensajes",
      "is typing...": "está escribiendo...",
      "Type a message...": "Escribe un mensaje...",
      "Select a conversation": "Selecciona una conversación",
      "Choose a conversation": "Elige una conversación en la barra lateral para comenzar a chatear",

      "Leaderboard": "Tabla de Líderes",
      "Our top learners": "Nuestros mejores aprendices en la comunidad",
      "Our top mentors": "Nuestros mejores mentores en la comunidad",
      "Top Mentors": "Mejores Mentores",
      "Top Learners": "Mejores Aprendices",
      "All": "Todos",
      "No leaders yet": "Aún no hay líderes",
      "Complete sessions to appear": "¡Completa sesiones y gana reseñas para aparecer aquí!",
      "learned": "aprendido",

      "Community Spaces": "Espacios Comunitarios",
      "Join skill-specific communities": "Únete a comunidades específicas de habilidades y conéctate con otros",
      "+ Create Community": "+ Crear Comunidad",
      "No communities yet": "Aún no hay comunidades",
      "Be the first to create": "¡Sé el primero en crear una comunidad!",
      "members": "miembros",
      "Joined": "Unido",
      "Join": "Unirse",
      "Icon": "Icono",
      "e.g. React Developers": "ej. Desarrolladores React",
      "Category": "Categoría",
      "e.g. Programming": "ej. Programación",
      "Description": "Descripción",
      "What is this community about?": "¿De qué trata esta comunidad?",
      "Create": "Crear",
      "Back to Communities": "← Volver a Comunidades",
      "Leave": "Salir",
      "Join Community": "Unirse a la Comunidad",
      "posts": "publicaciones",
      "Share something": "Comparte algo con la comunidad...",
      "Post": "Publicar",
      "No posts yet": "Aún no hay publicaciones. ¡Sé el primero en compartir!",
      "Edit": "Editar",
      "Delete": "Eliminar",
      "Save": "Guardar",
      "Write a reply...": "Escribe una respuesta...",
      "Reply": "Responder",

      "Welcome Back": "Bienvenido de nuevo",
      "Please enter details": "Por favor ingresa tus datos para iniciar sesión",
      "Email Address": "Correo Electrónico",
      "Password": "Contraseña",
      "Sign In": "Iniciar Sesión",
      "Don't have an account?": "¿No tienes una cuenta?",
      "Sign up here": "Regístrate aquí",

      "Create an Account": "Crear una Cuenta",
      "Join the community today": "Únete a la comunidad hoy",
      "Full Name": "Nombre Completo",
      "Create Account": "Crear Cuenta",
      "Already have an account?": "¿Ya tienes una cuenta?",
      "Sign in here": "Inicia sesión aquí",

      "Video Session": "Sesión de Video",
      "End Session": "Finalizar Sesión",
      "Share Screen": "Compartir Pantalla",
      "Stop Screen": "Detener Pantalla",
      "Waiting for other": "Esperando a que el otro participante se una...",
      "Weekly Challenges": "Desafíos Semanales",
      "Claim Reward": "Reclamar Recompensa",
      "Claimed": "Reclamado",
      "The Skill Sharer": "El Compartidor de Habilidades",
      "Complete 1 session as a Mentor this week": "Completa 1 sesión como Mentor esta semana",
      "The Avid Learner": "El Aprendiz Ávido",
      "Complete 1 session as a Learner this week": "Completa 1 sesión como Aprendiz esta semana",
      "Community Voice": "Voz de la Comunidad",
      "Write 1 post in any community this week": "Escribe 1 publicación en cualquier comunidad esta semana"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    }
  });

export default i18n;
